<mat-icon [matTooltipClass]="matTooltipClass" [matTooltip]="currentText" matTooltipPosition="right">help</mat-icon>
